import React from "react"

import { renderedListingSourceType } from "../../../../config/application-definitions"
import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import SourceEditItemDetails from "./SourceEditItemDetails"
import SourceEditRenderedListingDetails from "./SourceEditRenderedListingDetails"
import EditFeedItemInsightDetails from "../../../feed/knowledge-item/edit/EditFeedItemInsightDetails"
import SourceEditItemClassificationDetails from "./SourceEditItemClassificationDetails"

const SourceEditItem = ({
    model,
    renderedListingCheck,
    isCheckingRenderedListing,
    renderedListingCheckFailed,
    renderedListingTestLink,
    renderedListingDiscover,
    isDiscoveringRenderedListing,
    renderedListingDiscoverError,
    onEventChange,
    onValueChange,
    onImageChange,
    onTestLinkChange,
    onDiscover
}) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <SourceEditItemDetails
                name={model.name}
                url={model.url}
                description={model.description}
                active={model.active}
                favicon={model.favicon}
                imagePreviewURL={model.imagePreviewURL}
                onEventChange={onEventChange}
                onImageChange={onImageChange}
            />
            {model.type === renderedListingSourceType && (
                <SourceEditRenderedListingDetails
                    url={model.url}
                    linkPattern={model.link_pattern}
                    listingUrls={model.listing_urls}
                    check={renderedListingCheck}
                    isChecking={isCheckingRenderedListing}
                    checkFailed={renderedListingCheckFailed}
                    testLink={renderedListingTestLink}
                    discover={renderedListingDiscover}
                    isDiscovering={isDiscoveringRenderedListing}
                    discoverError={renderedListingDiscoverError}
                    onDiscover={onDiscover}
                    onEventChange={onEventChange}
                    onValueChange={onValueChange}
                    onTestLinkChange={onTestLinkChange}
                />
            )}
            <EditFeedItemInsightDetails
                topics={model.topics}
                onValueChange={onValueChange}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <SourceEditItemClassificationDetails
                type={model.type}
                lastImportTime={model.updated}
                preserveArticleLinks={model.preserve_article_links}
                publicationType={model.publication_type}
                contentType={model.content_type}
                country={model.country}
                language={model.language}
                license={model.license}
                autoApproved={model.auto_approved}
                onEventChange={onEventChange}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default SourceEditItem
